@if (!inSetupMode && !betaStringId) {
  <div class="fui-layout-container">
    <!--
      Migrated 2026-09-01 to the reusable `<fui-layout-header>` hero API. The wrapper
      div used to carry `.fui-hero-section` + `background-image` inline, and community's
      own `enableHeroNavMode()` managed `body.ghost-nav-route` + `appService.showGhostNav`
      + a scroll listener. All of that now lives inside the layout-header itself and
      fires whenever `[heroImageUrl]` is set — see `syncHeroNavMode()` in
      `layout-header.component.ts`.
    -->
    <fui-layout-header
      [breadcrumbs]="breadcrumbs"
      [headingText]="communityHeading"
      [description]="communityDescription"
      [loading]="!communityConfigLoaded"
      [heroImageUrl]="communityHeroImageUrl"
      [heroTheme]="communityHeroTheme"
    >
      @if (communityStringId == "fender-studio-pro") {
        <div class="fui-nav-pills m-t-30">
          <ul>
            <li>
              <button
                [class.active]="displayedSection == 'channels'"
                (click)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
                (keyup.enter)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
                (keyup.space)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
              >
                {{ "com.all_channels" | translate }}
              </button>
            </li>
            <!-- <li>
            <button
              [class.active]="displayedSection == 'topics'"
              (click)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
              (keyup.enter)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
              (keyup.space)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
              >
              Topics
            </button>
          </li> -->
            <li>
              <button
                [class.active]="displayedSection == 'connect'"
                (click)="appService.mobileMenuShown = false; switchSection('connect')"
                (keyup.enter)="appService.mobileMenuShown = false; switchSection('connect')"
                (keyup.space)="appService.mobileMenuShown = false; switchSection('connect')"
              >
                {{ "com.connect" | translate }}
              </button>
            </li>
            @if (user && appService.app === "fender" && !user?.banned && communityService.profile?.status != "banned") {
              <li>
                <button
                  (click)="appService.mobileMenuShown = false; goToFeatureRequests()"
                  (keyup.enter)="appService.mobileMenuShown = false; goToFeatureRequests()"
                  (keyup.space)="appService.mobileMenuShown = false; goToFeatureRequests()"
                >
                  {{ "com.post_types.feature_request" | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }
      <!-- Quiet way back into the migration explainer for someone who arrived without the
           `?discordMigration=true` link — a Discord announcement gets forwarded, pasted and
           re-shared, so plenty of people land here plainly. Hidden once they have linked,
           since by then it has nothing left to tell them. -->
      @if (showDiscordMigrationLink) {
        <button type="button" class="fui-discord-migration-link m-t-15" (click)="openDiscordMigrationHelp()">
          {{ "discord_migration.here_from_discord" | translate }}
        </button>
      }
      <!--
        The search / filters / settings strip used to live here, under an `<hr>`. It moved
        into the feed column beside the list-detail toggle (see `<myp-channel>` below), so
        the whole control strip is one row that pins to the top as you scroll — on a phone
        that is the difference between always having search and the channels button and
        having to scroll back up for them.
      -->
    </fui-layout-header>
  </div>
}

@if (!inSetupMode) {
  <main [class]="!betaStringId ? 'fui-layout-container' : 'column-layout-container'" #communityColumnLayoutContainer basepage="primary">
    @if (betaStringId) {
      <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
        <aside role="region" aria-label="side navigation">
          <div class="menu-top d-flex justify-content-between align-items-center">
            @if (!betaStringId) {
              <fui-heading [text]="'com.community' | translate" [level]="2" fontSize="f7"></fui-heading>
            }
            @if (betaStringId) {
              <div class="d-flex align-items-center">
                <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="'com.back_to_beta_programs' | translate" [routerLink]="['/beta']">
                  <fa-icon icon="chevron-left" class="action circle-icon-btn"></fa-icon>
                </button>
                <span [routerLink]="['/beta']">
                  <fui-heading [text]="'beta.programs' | translate" [level]="2" fontSize="f7"></fui-heading>
                </span>
              </div>
            }
          </div>
          @if (!displayedChannels?.length) {
            <myp-skeleton-loader extraContainerClass="m-y-20" [number]="18" type="line" [useRandomWidth]="true" height="10px"></myp-skeleton-loader>
          }
          <ul class="menu-options">
            @if (displayedChannels?.length && !betaStringId && (displayedSection == "channels" || displayedSection == "search")) {
              <div class="m-r-10">
                <div class="form-group">
                  <label class="control-label" for="search-all-post">{{ "com.search_all_posts" | translate }}</label>
                  <div class="product-filter m-b-20">
                    <div class="filter-input">
                      <input id="search-all-post" type="text" (keyup.enter)="search()" [(ngModel)]="query" [placeholder]="'com.enter_query' | translate" />
                      @if (query) {
                        <button type="button" class="border-0 btn-transparent clear p-0 bg-transparent" (click)="clear()">
                          <fa-icon icon="times" aria-hidden="true"></fa-icon>
                          <span class="sr-only">clear search</span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (betaStringId) {
              <li class="menu-option" [class.active]="displayedSection == 'betadetails'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; switchSection('betadetails')"
                  (keyup.space)="appService.mobileMenuShown = false; switchSection('betadetails')"
                  (click)="appService.mobileMenuShown = false; switchSection('betadetails')"
                >
                  {{ "com.beta_details" | translate }}
                </a>
              </li>
            }
            @if (!betaStringId || betaCommunityTags?.length) {
              <li class="menu-option" [class.active]="displayedSection == 'channels'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
                  (keyup.space)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
                  (click)="appService.mobileMenuShown = false; showChannel('all_posts', true)"
                >
                  @if (!betaStringId) {
                    {{ "com.all_channels" | translate }}
                  }
                  @if (betaStringId) {
                    {{ "com.bugs_feature_requests" | translate }}
                  }
                </a>
                @if (this.displayedChannels?.length && betaStringId && (displayedSection == "channels" || displayedSection == "search")) {
                  <div class="m-r-10 m-t-10">
                    <div class="product-filter m-b-20">
                      <div class="filter-input">
                        <input type="text" (keyup.enter)="search()" [(ngModel)]="query" placeholder="{{ 'com.search_all_posts' | translate }}..." />
                        @if (query) {
                          <button type="button" class="border-0 btn-transparent clear p-0 bg-transparent" (click)="clear()">
                            <fa-icon icon="times" aria-hidden="true"></fa-icon>
                            <span class="sr-only">clear search</span>
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div>
                    <fui-sidebar-filter #fuiSidebarFilterBeta [visible]="true" [showHideButton]="false" [inMenu]="true">
                      <ng-container *ngTemplateOutlet="betaFilterContent"></ng-container>
                    </fui-sidebar-filter>
                  </div>
                }
                @if (displayedChannels && displayedChannels.length) {
                  <div class="menu-suboptions">
                    @for (channel of displayedChannels; track channel) {
                      <div class="sub-option d-block">
                        <a
                          tabindex="0"
                          href="javascript:void(0);"
                          (keyup.enter)="showChannel(channel, true)"
                          (keyup.space)="showChannel(channel, true)"
                          [class.active]="displayedSection == 'channels' && selectedChannel && selectedChannel.string_id == channel.string_id"
                          (click)="appService.mobileMenuShown = false; showChannel(channel, true)"
                        >
                          {{ channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? "#" : "" }}
                          {{ channel.title | localize: channel.string_id }}
                          @if (betaStringId && communityService.betaTagCountMap && communityService.betaTagCountMap[channel.string_id]) {
                            <span class="badge">
                              {{
                                channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? communityService.betaTagCountMap[channel.string_id] : ""
                              }}
                            </span>
                          }
                        </a>
                      </div>
                    }
                  </div>
                }
              </li>
            }
            @if (allTopics && allTopics.length) {
              <li class="menu-option" [class.active]="displayedSection == 'topics'">
                @if (topics.length || user?.is_sphere_admin) {
                  <a
                    class="primary-option"
                    tabindex="0"
                    href="javascript:void(0);"
                    (keyup.enter)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                    (keyup.space)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                    (click)="appService.mobileMenuShown = false; showTopic(topics[0], true)"
                  >
                    {{ "com.topics" | translate }}
                  </a>
                }
                <div class="menu-suboptions">
                  @for (topic of showingAllTopics ? allTopics : topics; track topic) {
                    <div class="sub-option d-block">
                      <a
                        tabindex="0"
                        href="javascript:void(0);"
                        (keyup.enter)="showTopic(topic, true)"
                        (keyup.space)="showTopic(topic, true)"
                        [class.archived]="topic.archived"
                        [class.active]="displayedSection == 'topics' && selectedTopic && selectedTopic?.title == topic.title"
                        (click)="appService.mobileMenuShown = false; showTopic(topic, true)"
                      >
                        {{ topic.title }}
                        @if (topic.archived) {
                          <span class="tiny-pill">{{ "com.archived" | translate }}</span>
                        }
                      </a>
                    </div>
                  }
                  @if (user?.is_sphere_admin) {
                    <div class="m-l-10">
                      <a [routerLink]="['/admin/community_topics']" class="small-btn m-r-10">{{ "com.manage_topics" | translate }}</a>
                      @if (user?.active_subscription && allTopics.length > topics.length) {
                        <button class="small-btn" (click)="showingAllTopics = !showingAllTopics">
                          {{ showingAllTopics ? ("com.hide_archived_topics" | translate) : ("com.view_archived_topics" | translate) }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </li>
            }
            @if (!betaStringId) {
              <li class="menu-option" [class.active]="displayedSection == 'connect'">
                <a
                  class="primary-option"
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="appService.mobileMenuShown = false; switchSection('connect')"
                  (keyup.space)="appService.mobileMenuShown = false; switchSection('connect')"
                  (click)="appService.mobileMenuShown = false; switchSection('connect')"
                >
                  {{ "com.connect" | translate }}
                </a>
              </li>
            }
          </ul>
        </aside>
      </div>
    }
    @if (!betaStringId) {
      <div class="fui-sidebar-content-container" [style.--community-accent]="communityAccent">
        <fui-sidebar-filter #fuiSidebarFilter [visible]="showTags && displayedSection == 'channels'" [showHideButton]="true" extraClasses="community-channel-rail" (hideClicked)="showTags = false">
          <ng-container *ngTemplateOutlet="filterContent"></ng-container>
        </fui-sidebar-filter>
        <ng-container *ngTemplateOutlet="mainCommunityContent"></ng-container>

        <!--
          Split-pane post detail. Opens beside the list instead of on its own page, with
          the URL still set to the post's own — see `openSelectedPost`. The divider between
          them is a drag handle; `paneWidth` is the pane's flex-basis and is persisted.

          Only for the LIST view on a wide viewport: `splitPaneActive` folds in the
          layout check, and below it the feed falls back to full-page navigation.
        -->
        @if (splitPaneActive && selectedPostId) {
          <div
            class="community-split-divider"
            role="separator"
            aria-orientation="vertical"
            [attr.aria-label]="'Resize post panel'"
            tabindex="0"
            (keydown)="onDividerKeydown($event)"
            mypPaneResizer
            (paneResize)="onPaneResize($event)"
          ></div>
          <aside class="community-split-pane" [style.flex-basis.px]="paneWidth">
            <myp-community-post-detail [embedded]="true" [postIdInput]="selectedPostId" [communityStringId]="communityStringId" (closed)="closePostPane()"></myp-community-post-detail>
          </aside>
        }
      </div>
    }
    @if (betaStringId) {
      <div class="fui-sidebar-content-container">
        <ng-container *ngTemplateOutlet="mainCommunityContent"></ng-container>
      </div>
    }
    <ng-template #mainCommunityContent>
      <section
        [class]="!betaStringId ? 'fui-layout-pad-content m-t-30' : 'content animate-in-from-right'"
        [class.fui-sidebar-shown]="showTags && displayedSection == 'channels' && !betaStringId"
        [class.community-split-feed]="splitPaneActive && selectedPostId"
        #contentContainer
        (scroll)="contentContainerScrolled($event)"
        [class.mobile-shown]="!appService.mobileMenuShown"
      >
        @if (betaStringId) {
          <button class="mobile-back-btn no-border" (click)="appService.mobileMenuShown = true">
            <fa-icon icon="chevron-left"></fa-icon>
            @if (!betaStringId) {
              {{ "com.community" | translate }}
            }
            @if (betaStringId) {
              Beta Options
            }
          </button>
        }
        <div>
          @if (displayedSection == "search") {
            <myp-community-search
              [betaStringId]="betaStringId"
              [communityStringId]="communityStringId"
              #searchCmp
              [query]="selectedQuery"
              (scrollToTop)="scrollToTop()"
              (postsLoaded)="postsLoaded()"
              (viewPost)="showPostDetail($event)"
              (clearSearch)="clear()"
            ></myp-community-search>
          }
        </div>
        @if (!shouldShowPostDetails) {
          <div>
            @if (displayedSection == "betadetails" && betaProgram) {
              <myp-beta-details [betaProgram]="betaProgram"></myp-beta-details>
            }
            @if (displayedSection == "connect") {
              <myp-connect [browsingSkillId]="browsingSkillId" [skills]="skills"></myp-connect>
            }
            <!-- <myp-inline-loader [loading]="loading" height="400px" spinnerName="postLoader"></myp-inline-loader> -->
            @if (postsLoading && !showFullPageDetail) {
              <div style="width: 200px">
                <myp-skeleton-loader type="line" height="40px" width="100%"></myp-skeleton-loader>
              </div>
              <div>
                <myp-skeleton-loader extraContainerClass="m-t-20 m-b-30" max="100%" borderRadius="10px" type="carousel" height="100px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="300px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="100px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="200px"></myp-skeleton-loader>
                <myp-skeleton-loader extraContainerClass="m-y-40" max="100%" borderRadius="10px" type="carousel" height="340px"></myp-skeleton-loader>
              </div>
            }

            @if (displayedSection == "channels" && selectedChannel && betaStringId) {
              <div class="community-post beta-header">
                {{ "com.beta_community_for" | translate }}
                <br />
                <fui-heading [text]="betaProgram.title" [level]="2" textAlign="center" fontSize="f8"></fui-heading>
              </div>
            }
            @if (displayedSection == "channels" && selectedChannel && betaStringId) {
              @if (betaAnnouncements?.length) {
                <div>
                  <div class="section-header m-t-20">
                    <fui-heading [text]="'com.announcements' | translate" [level]="2" fontSize="f7"></fui-heading>
                    <span class="section-header-link" (click)="toggleAnnouncementsCollapsed()">
                      {{ announcementsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                      <fa-icon [icon]="announcementsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                    </span>
                  </div>
                  @if (!announcementsCollapsed) {
                    <div class="m-t-20">
                      @for (ann of betaAnnouncements; track ann) {
                        <myp-comment
                          [betaStringId]="betaStringId"
                          [communityStringId]="communityStringId"
                          [comment]="ann"
                          [isCommunityPost]="true"
                          [isAnnouncement]="true"
                          [replies]="communityService.activeParentThreadMap[ann.key]"
                          (channelSelected)="channelSelected($event)"
                        ></myp-comment>
                      }
                    </div>
                  }
                  @if (announcementsCollapsed) {
                    <div class="text-muted m-b-20">{{ betaAnnouncements.length }} Announcement{{ betaAnnouncements.length > 1 ? "s" : "" }} Hidden.</div>
                  }
                </div>
              }
            }
            <!--
              A post URL on a layout that can't host the pane (narrow viewport, or the
              detailed feed) renders the detail full-width right here, in place of the feed.
              Same component, same URL. `hosted` tells it the feed is still mounted behind
              it, so its back button closes this instead of navigating — the list comes back
              instantly, on this community, where the member left it.
            -->
            @if (showFullPageDetail) {
              <!-- `postIdInput` explicitly: the route snapshot is only correct when this page
                   was actually navigated to, and a pane opened via `location.go` leaves it
                   pointing at the channel. -->
              <myp-community-post-detail
                #fullPageDetail
                class="community-inline-detail"
                [hosted]="true"
                [communityStringId]="communityStringId"
                [postIdInput]="selectedPostId"
                (closed)="closeFullPageDetail()"
              ></myp-community-post-detail>
            }
            <!--
              HIDDEN, not removed, when the full-width detail is up. Unmounting the feed meant
              `postsLoaded` never fired, so `postsLoading` stayed true and the page's skeleton
              loaders sat above the post forever — and the feed had to refetch on the way back.
              Kept mounted, it loads underneath and back is instant.
            -->
            <div [hidden]="showFullPageDetail">
              @if ((displayedSection == "channels" && selectedChannel) || (displayedSection == "topics" && selectedTopic)) {
                <myp-channel
                  #channelCmp
                  (postsLoaded)="postsLoaded($event)"
                  [postType]="displayedSection"
                  (channelSelected)="channelSelected($event)"
                  (resetFilters)="resetFilters()"
                  [selectedChannel]="selectedChannel"
                  [searchQuery]="query"
                  (topicSelected)="displayedSection = 'topics'; selectedChannel = undefined; selectedTopic = webCommunityService.topicMap[$event]"
                  [selectedTopic]="selectedTopic"
                  [betaStringId]="betaStringId"
                  [communityStringId]="communityStringId"
                  [selectedBetaView]="selectedBetaView"
                  [splitPaneActive]="splitPaneActive"
                  [selectedPostId]="selectedPostId"
                  [compactList]="compactList"
                  (openPost)="openSelectedPost($event)"
                  (viewModeChanged)="onViewModeChanged($event)"
                >
                  <!--
                    Projected into the channel's sticky toolbar, beside the list/detail
                    toggle. It stays declared HERE because every handler on it is this
                    component's — `query`, `search()`, the sidebar modal, the settings
                    modal — and projection keeps the binding context where it belongs
                    rather than threading six inputs and outputs through the channel.
                    The channel only renders `<ng-content>` for non-beta, so beta (which
                    has its own filter sidebar) never shows this.
                  -->
                  <div channelToolbar class="fui-community-actions-row d-flex align-items-center">
                    <div class="fui-community-actions-search-wrap">
                      <fui-content-filter
                        #fuiContentFilter
                        [showViewOption]="false"
                        [showSidebarToggle]="false"
                        [activeQuery]="query"
                        [showResults]="false"
                        [showSortOptionsToggle]="false"
                        [searchOnlyOnEnter]="true"
                        (refineClicked)="showTags = !showTags"
                        (clearQuery)="query = ''; search()"
                        (queryChanged)="query = $event; search()"
                        (showMobileFiltersClicked)="fuiSidebarFilter?.showMobileModal()"
                      ></fui-content-filter>
                    </div>
                    <!--
                      Hamburger circle — the sole filter-toggle affordance for this row on ALL
                      viewports (2026-09-01, matching the /communities pattern). Above the
                      layout breakpoint it toggles `showTags` inline; below it there is no
                      inline rail, so it opens the modal — see `toggleFilters()`.
                      `<fui-content-filter>`'s built-in Show/Hide Filters text buttons are
                      suppressed via `[showSidebarToggle]="false"` above.
                    -->
                    <button type="button" class="fa-button fui-hamburger-btn m-l-10" placement="bottom" [ngbTooltip]="'Filters'" aria-label="Show filters" (click)="toggleFilters()">
                      <fa-icon icon="bars" class="action circle-icon-btn"></fa-icon>
                    </button>
                    <!--
                      Opens the per-community notification preferences modal (DENG-733).
                      Same `fa-button` + `circle-icon-btn` pattern as the beta back-button
                      and the admin edit buttons — click target on the button, visual circle
                      on the icon.
                    -->
                    @if (user && !user?.banned && communityService.profile?.status != "banned") {
                      <button
                        type="button"
                        class="fa-button m-l-10"
                        placement="bottom"
                        [ngbTooltip]="'Community settings'"
                        [attr.aria-label]="'Settings for ' + (communityHeading || 'this community')"
                        (click)="openCommunitySettings()"
                      >
                        <!-- Gear, not a bell: the modal covers notifications AND the post
                             signature (DENG-847), and matches the gear already on the
                             /communities cards. -->
                        <fa-icon icon="cog" class="action circle-icon-btn"></fa-icon>
                      </button>
                    }
                  </div>
                </myp-channel>
              }
            </div>
          </div>
        }
      </section>
    </ng-template>
  </main>
}

@if (inSetupMode) {
  <main basepage="primary" class="fullwidth-layout-container h-full">
    <div class="d-flex align-items-center justify-content-center h-full">
      <div class="text-center position-relative" style="max-width: 800px">
        <myp-community-onboarding-wizard [communityStringId]="communityStringId" (complete)="onOnboardingWizardComplete()"></myp-community-onboarding-wizard>
      </div>
    </div>
  </main>
}

<div class="fui-layout-container">
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>

@if (shouldShowMemberResults) {
  <myp-member-results-overlay (closeClicked)="closeMemberResults()" [searchResults]="searchResults"></myp-member-results-overlay>
}

<!-- Reusable filter content template -->
<ng-template #filterContent>
  @if (!displayedChannels?.length) {
    <myp-skeleton-loader type="line" extraContainerClass="m-y-30" [useRandomWidth]="true" [number]="18" height="10px"></myp-skeleton-loader>
  }
  <ul>
    @for (channel of displayedChannels; track channel) {
      <!--
        `community-channel-item` scopes the unread treatment to this rail: the shared
        `.fui-primary-category` is bold everywhere (Products, Exchange, Account all render
        it), and here bold has to MEAN something — it marks a channel with new posts.
      -->
      <li
        class="fui-primary-category community-channel-item"
        [class.selected]="displayedSection == 'channels' && selectedChannel && selectedChannel.string_id == channel.string_id"
        [class.has-unread]="channelUnread[channel.string_id] > 0"
      >
        <a
          tabindex="0"
          href="javascript:void(0);"
          (keyup.enter)="showChannel(channel, true); appService.closeModals()"
          (keyup.space)="showChannel(channel, true); appService.closeModals()"
          (click)="appService.mobileMenuShown = false; showChannel(channel, true); appService.closeModals()"
        >
          <span class="community-channel-item__title">
            {{ channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? "#" : "" }}{{ channel.title | localize: channel.string_id }}
          </span>
          @if (betaStringId && communityService.betaTagCountMap && communityService.betaTagCountMap[channel.string_id]) {
            <span class="badge">
              {{ channel.string_id != "all_posts" && channel.string_id != "pinned_posts" && channel.string_id != "my_posts" ? communityService.betaTagCountMap[channel.string_id] : "" }}
            </span>
          }
          <!-- Capped at 99+: the query only looks at the newest 300 posts across the whole
               community, so a bigger number would be claiming precision it doesn't have. -->
          @if (channelUnread[channel.string_id]) {
            <span class="fui-filter-badge community-unread-badge" [attr.aria-label]="channelUnread[channel.string_id] + ' new posts'">
              {{ channelUnread[channel.string_id] > 99 ? "99+" : channelUnread[channel.string_id] }}
            </span>
          }
        </a>
      </li>
    }
  </ul>
  @if (hasUnreadChannels) {
    <button type="button" class="community-mark-all-read" (click)="markAllChannelsRead(); appService.closeModals()">Mark all read</button>
  }
</ng-template>

<!-- Beta filter content template -->
<ng-template #betaFilterContent>
  <div class="m-r-10 m-b-20">
    <span class="font-weight-bold t-15 p-10 d-block">{{ "com.display" | translate }}</span>
    <myp-segmented-bar [white]="true" [nowrap]="true" [id]="'beta-view-segmented-bar'" (selected)="selectBetaView($event.id)" [options]="betaViewOptions"></myp-segmented-bar>
    <span class="font-weight-bold t-15 p-10 d-block m-t-20">{{ "com.sorting" | translate }}</span>
    <select class="form-control custom-select-sm m-r-10" (change)="filter()" [(ngModel)]="filters.sort">
      <option value="date">{{ "com.sort_newest" | translate }}</option>
      <!-- <option value="activity">Most Replies</option> -->
      <option value="recentactivity">{{ "com.sort_recent_replies" | translate }}</option>
    </select>
    <span class="font-weight-bold t-15 p-10 d-block m-t-20">{{ "com.filters" | translate }}</span>
    <select class="form-control custom-select-sm m-r-10" (change)="filter()" [(ngModel)]="filters.type">
      <option value="all">{{ "com.post_types.all" | translate }}</option>
      <option value="bug">{{ "com.post_types.bug" | translate }}</option>
      <option value="feature_request">{{ "com.post_types.feature_request" | translate }}</option>
      <option value="post">{{ "com.post_types.post" | translate }}</option>
      <option value="none">{{ "com.post_types.none" | translate }}</option>
    </select>
    <select class="form-control custom-select-sm m-r-10 m-t-10" (change)="filter()" [(ngModel)]="filters.status">
      <option value="all">{{ "com.status_any" | translate }}</option>
      <option value="none">{{ "com.beta_status.none" | translate }}</option>
      <option value="open">{{ "com.beta_status.open" | translate }}</option>
      <option value="cannot_reproduce">{{ "com.beta_status.cannot_reproduce" | translate }}</option>
      <option value="fixed">{{ "com.beta_status.fixed" | translate }}</option>
      <option value="investigating">{{ "com.beta_status.investigating" | translate }}</option>
      <option value="accepted">{{ "com.beta_status.accepted" | translate }}</option>
      <option value="rejected">{{ "com.beta_status.rejected" | translate }}</option>
      <option value="duplicate">{{ "com.beta_status.duplicate" | translate }}</option>
      <option value="by_design">{{ "com.beta_status.by_design" | translate }}</option>
    </select>
    <select class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" (change)="filter()" [(ngModel)]="filters.reviewStatus">
      <option value="all">{{ "com.review_status.all" | translate }}</option>
      <option value="true">{{ "com.review_status.reviewed" | translate }}</option>
      <option value="false">{{ "com.review_status.not_reviewed" | translate }}</option>
    </select>
    @if (communityService.filteredBetaAuthorList?.length || communityService.betaAuthorList?.length) {
      <select class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" (change)="filter()" [(ngModel)]="filters.author">
        <option value="all">{{ "com.any_author" | translate }}</option>
        @for (author of communityService.filteredBetaAuthorList || communityService.betaAuthorList; track author) {
          <option [value]="author.id">{{ author.name }}</option>
        }
      </select>
    } @else if (!communityService.betaAuthorList) {
      <select class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" disabled aria-busy="true">
        <option>Loading authors…</option>
      </select>
    }
    <input class="form-control custom-select-sm m-r-10 m-t-10 m-b-10" placeholder="Jira Ticket Number" type="text" (keyup.enter)="filter()" [(ngModel)]="filters.jiraTicketNumber" />
    <button class="btn btn-primary btn-sm" (click)="resetFilters()">{{ "education.reset_filters" | translate }}</button>
  </div>
</ng-template>
